export const createOrderMutation = async ({ publicClient, values }) => {
  const { data } = await publicClient.post(`/services/new_order/`, {
    ...values,
  });
  return data;
};
